import { render, staticRenderFns } from "./editBudget.vue?vue&type=template&id=b0c15172&scoped=true&"
import script from "./editBudget.vue?vue&type=script&lang=js&"
export * from "./editBudget.vue?vue&type=script&lang=js&"
import style0 from "./editBudget.vue?vue&type=style&index=0&id=b0c15172&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c15172",
  null
  
)

export default component.exports